
import isEmpty from "lodash/isEmpty";
export class ArrayEditActionEntity {
  add?: Array<string>;
  erase?: Array<string>;
}

export class UserPermissionActionRequestEntity {
  name?: string;
  code?: string;
  type?: string;
  status?: string;
  note?: string;
  order?: string;
  isLog?: boolean;
  path?: string;
  configuration?: Record<string, unknown>;
  blackList?: Array<string> | ArrayEditActionEntity;
  users?: Array<string> | ArrayEditActionEntity;

  constructor(data?: Partial<UserPermissionActionRequestEntity>) {
    this.name = data?.name;
    this.code = data?.code;
    this.type = data?.type;
    this.status = data?.status;
    this.note = data?.note;
    this.order = data?.order;
    this.isLog = data?.isLog;
    this.path = data?.path;
    this.configuration = data?.configuration;
    this.blackList = data?.blackList;
    this.users = data?.users;
  }

  public isIncludePath?() {
    return this.path && !isEmpty(this.path);
  }

  public isUpdateAction?() {
    return !!this.code && !isEmpty(this.code);
  }
}
